import { Circle } from 'shared/ui/Circle'

import { palette } from 'shared/config/styles/palette'

const NewOrderBadge = () => {
  return (
    <div className="flex gap-1 px-1.5 py-0.5 text-xs leading-4 text-dark bg-yellow rounded-3xl">
      <Circle
        size={4}
        sameWrapperSize={true}
        color={palette.brown}
      />
      Новый
    </div>
  )
}

export default NewOrderBadge
